<template>
    <Modal
        v-model="showModal"
        title="认可关系详情"
        :mask-closable="false"
        width="900"
        class="seedfarm-accept-modal"
    >
        <div class="modal-content">
            <!-- 基本信息 -->
            <div class="section">
                <h3 class="section-title">基本信息</h3>
                <Row :gutter="16">
                    <Col span="8">
                        <div class="info-item">
                            <label>客户经理编号：</label>
                            <span>{{ detailData.userCustomerManagerCode }}</span>
                        </div>
                    </Col>
                    <Col span="8">
                        <div class="info-item">
                            <label>客户经理姓名：</label>
                            <span>{{ detailData.userCustomerManagerName }}</span>
                        </div>
                    </Col><Col span="8">
                        <div class="info-item">
                            <label>认可状态：</label>
                            <Tag :color="getStatusColor(detailData.recordStatus)">
                                {{ getStatusText(detailData.recordStatus) }}
                            </Tag>
                        </div>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="8">
                        <div class="info-item">
                            <label>苗场编号：</label>
                            <span>{{ detailData.seedFarmCode }}</span>
                        </div>
                    </Col>
                    <Col span="8">
                        <div class="info-item">
                            <label>苗场名称：</label>
                            <span>{{ detailData.seedFarmName }}</span>
                        </div>
                    </Col>
                    <Col span="8">
                        <div class="info-item">
                            <label>创建人：</label>
                            <span>{{ detailData.creatorName }}</span>
                        </div>
                    </Col>
                    
                </Row>
                <Row :gutter="16">
                    <Col span="8">
                        <div class="info-item">
                            <label>创建人编号：</label>
                            <span>{{ detailData.creatorCode }}</span>
                        </div>
                    </Col>
                    <Col span="8">
                        <div class="info-item">
                            <label>修改人：</label>
                            <span>{{ detailData.modifierName }}</span>
                        </div>
                    </Col>
                    <Col span="8">
                        <div class="info-item">
                            <label>修改人编号：</label>
                            <span>{{ detailData.modifierCode }}</span>
                        </div>
                    </Col>
                </Row>
            </div>

            <Divider />
        </div>

        <div slot="footer">
            <Button @click="handleClose">关闭</Button>
        </div>
    </Modal>
</template>

<script>
import { getSeedFarmAcceptCusMgrInfo } from '@/api/modules/system-management/seedFarm-management';
export default {
    name: 'SeedfarmAcceptCusmgrModal',
    data() {
        return {
            showModal: false,
            detailData: {}
        };
    },
    methods: {
        // 打开弹窗
        open(id) {
            this.getSeedfarmAcceptCusmgr(id);
            
        },
        getSeedfarmAcceptCusmgr(id){
            let data = {
                uuid: id
            };
            getSeedFarmAcceptCusMgrInfo(data).then(res => {
                if (res.code === 0 && res.data && res.data.records) {
                    this.detailData = res.data.records;
                    this.showModal = true;
                } else {
                    this.$Message.error('获取认可关系详情失败');
                    this.showModal = false;
                }
            }).catch(err => {
                console.error('获取认可关系详情异常:', err);
                this.$Message.error('获取认可关系详情异常');
                this.showModal = false;
            });
        },
        // 关闭弹窗
        close() {
            this.showModal = false;
            this.detailData = {};
        },
        // 处理关闭
        handleClose() {
            this.close();
        },
        // 处理编辑
        handleEdit() {
            this.$emit('edit', this.detailData);
            this.close();
        },
        // 获取状态颜色
        getStatusColor(status) {
            const statusMap = {
                0: 'default',
                1: 'success'
            };
            return statusMap[status];
        },
        // 获取状态文本
        getStatusText(status) {
            const statusMap = {
                0: '否',
                1: '是'
            };
            return statusMap[status] || '未知';
        },
        // 获取操作类型颜色
        getOperationTypeColor(type) {
            const typeMap = {
                '创建': 'primary',
                '审核': 'success',
                '更新': 'warning',
                '删除': 'error'
            };
            return typeMap[type] || 'default';
        }
    }
};
</script>

<style lang="less" scoped>
.seedfarm-accept-modal {
    .modal-content {
        max-height: 600px;
        overflow-y: auto;
    }

    .section {
        margin-bottom: 20px;

        .section-title {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 12px;
            color: #2d8cf0;
        }
    }

    .info-item {
        margin-bottom: 10px;

        label {
            font-weight: bold;
            color: #666;
            display: inline-block;
            width: 100px;
        }

        span {
            color: #333;
        }
    }

    .remark-content {
        background-color: #f8f8f9;
        padding: 12px;
        border-radius: 4px;
        border-left: 3px solid #2d8cf0;

        p {
            margin: 0;
            line-height: 1.6;
            color: #666;
        }
    }
}
</style>